// SteffiAvatarPlayer.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import SteffiAvatar from "./SteffiAvatar";

/**
 * Props:
 *  - sequence: Array<{ mouth: string, eyes: string, extra: string, duration: number }>
 *  - loop: boolean (default true)
 *  - autoplay: boolean (default true)
 *  - className: optional
 */
export default function SteffiAvatarPlayer({
  sequence = [],
  loop = true,
  autoplay = true,
  className = "w-64",
}) {
  const [i, setI] = useState(0);
  const timerRef = useRef(null);

  const frame = useMemo(() => sequence[i] ?? sequence[0] ?? null, [sequence, i]);

  useEffect(() => {
    if (!autoplay || !frame) return;
    // Clear any previous timer
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      if (i + 1 < sequence.length) {
        setI(i + 1);
      } else if (loop && sequence.length > 0) {
        setI(0);
      }
    }, Math.max(0, frame.duration || 300));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [autoplay, frame, i, loop, sequence]);

  if (!frame) return null;

  return (
    <div className={className}>
      <SteffiAvatar eyebrows= {frame.eyebrows} mouth={frame.mouth} eyes={frame.eyes} extra={frame.extra} />
    </div>
  );
}